export enum GoogleLocationType {
  ROOFTOP = 'ROOFTOP',
  RANGE_INTERPOLATED = 'RANGE_INTERPOLATED',
  GEOMETRIC_CENTER = 'GEOMETRIC_CENTER',
  APPROXIMATE = 'APPROXIMATE',
}
